import { Link } from "react-router-dom";
import useCategories from '../../../../hooks/use-categories';
import useLocalization from '../../../../hooks/use-localization';

export default function Meta({ author, categories }) {

    const localization = useLocalization();
    const globalCategories = useCategories();

    const categoriesRendered = categories.map(c => {

        const path = `/news/${c}`;
        const localizedText = globalCategories[c];

        return <span key={c} className="post-category-link">
            <Link to={path}>{localizedText}</Link> <span>/</span>
        </span>
    });

    return (
        <div className="entry-meta">
            <span>{localization.author}</span>
            <span>{author}</span>
            <span>|</span>
            <i className="fa fa-sitemap"></i>
            <span>{categoriesRendered}</span>
        </div>
    );
}